import React, { useState } from 'react';
import Select, { SelectOption } from '@amzn/meridian/select';
import Text from '@amzn/meridian/text';

export const AwsAccountDropdown = ({ awsAccounts, onChange }) => {
  const [value, setValue] = useState('');

  const handleChange = newValue => {
    setValue(newValue);
    onChange(newValue);
  };

  return (
    <>
      <Text className="mb-1" tag="label" type="h100" color="primary" htmlFor="aws-account-select">
        Aws Account
      </Text>
      <Select id="aws-account-select" value={value} onChange={handleChange} el-width="100%">
        <SelectOption key="" value="" label="ALL" />
        {
          // set aws account dropdowns
          awsAccounts.map(option => (
            <SelectOption
              key={option.awsAccountId}
              value={option.awsAccountId}
              label={option.name + ' (' + option.awsAccountId + ')'}
            />
          ))
        }
      </Select>
    </>
  );
};
